// ----------------------------------------------------------------------
// The origin Supabase sends the user back to after an emailed link.
//
// Not window.location.origin, deliberately. Supabase only redirects to a
// target on the project's Redirect URLs allow list and otherwise falls back to
// the Site URL — silently, tokens attached, on the wrong page. The list is
// matched by exact host, and the allow-listed entries (and the Site URL) are
// the apex lingoyouniverse.com, while the site is browsed on
// www.lingoyouniverse.com — to the allow list, two unrelated hosts. So every
// link built from the address bar was refused and dropped the user on the
// portal chooser instead of the new-password page.
//
// Asking for the apex works today: it is allow-listed, and Netlify 301s it to
// www keeping path, query and fragment, so the user still arrives on www.
// Local development sets its own origin in .env.local.
// ----------------------------------------------------------------------

const ORIGIN =
  (process.env.REACT_APP_AUTH_REDIRECT_ORIGIN || '').replace(/\/+$/, '') ||
  window.location.origin;

/** Absolute URL for `path` on the origin Supabase is allowed to send us to. */
export function authRedirectUrl(path = '/') {
  return `${ORIGIN}${path}`;
}
